document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.site-header__menu-toggle');
  var nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Product image thumbnails swap main image
  var thumbs = document.querySelectorAll('.product__thumb');
  var mainImage = document.querySelector('.product__main-image img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage && thumb.dataset.full) {
        mainImage.src = thumb.dataset.full;
      }
    });
  });
});
